var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 279,
    viewBox: "0 0 236 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.772 99.6498C112.772 99.6498 172.726 131.903 202.457 215.434L212.89 218.479L185.652 238.67L123.696 173.882L88.3318 158.309L83.5513 99.6498",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.327 101.971C103.327 101.971 110.473 218.591 90.292 273.807L94.5074 280H58.6139C58.6139 280 54.6926 131.666 54.6926 99.6499L103.327 101.971Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2269 11.741V26.897L72.4519 31.5113V5.93493L91.2269 1.32056V11.741Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6214 16.9847C80.8986 16.9847 81.1234 16.76 81.1234 16.4827C81.1234 16.2055 80.8986 15.9807 80.6214 15.9807C80.3441 15.9807 80.1194 16.2055 80.1194 16.4827C80.1194 16.76 80.3441 16.9847 80.6214 16.9847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3318 16.9847C88.6091 16.9847 88.8339 16.76 88.8339 16.4827C88.8339 16.2055 88.6091 15.9807 88.3318 15.9807C88.0546 15.9807 87.8298 16.2055 87.8298 16.4827C87.8298 16.76 88.0546 16.9847 88.3318 16.9847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0698 19.4773V11.7411H89.9455",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6758 11.7411H83.5514",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6887 15.705V18.3916C72.9928 18.3916 72.3253 18.1151 71.8332 17.623C71.3412 17.1309 71.0647 16.4635 71.0647 15.7676C71.0647 15.6871 71.0683 15.6075 71.0754 15.5288C71.2225 13.8993 73.6887 14.069 73.6887 15.705Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6889 18.3916C72.993 18.3916 72.3256 18.1151 71.8335 17.623C71.3414 17.1309 71.0649 16.4635 71.0649 15.7676",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3745 21.3846C84.0258 21.3846 83.6804 21.3159 83.3582 21.1824C83.036 21.0489 82.7432 20.8533 82.4966 20.6067C82.25 20.3601 82.0544 20.0673 81.9209 19.7451C81.7874 19.4229 81.7188 19.0775 81.7188 18.7288",
    stroke: "#FF6498",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2272 26.8969L72.4521 31.5114",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0698 19.4835L84.3748 19.9002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4523 22.3352C72.4523 22.3352 67.4101 12.3658 69.7107 6.34871C72.0114 0.331647 89.3547 -0.730187 92.3042 1.03954C95.2538 2.80926 92.6281 9.46782 91.2273 10.4744",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3201 14.7775C73.3201 14.7775 74.9609 12.7198 75.5508 8.70842C75.5508 8.70842 88.9766 7.86226 91.2273 6.76172",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M112.772 58.6514V99.6499L54.6926 113.925V68.2638C54.6926 60.3963 57.3305 52.756 62.1846 46.5645C67.0386 40.373 73.8285 35.9877 81.4685 34.1099H81.4686C85.1899 33.1953 89.0704 33.1389 92.8167 33.945C96.563 34.7511 100.077 36.3986 103.093 38.7629C106.108 41.1272 108.547 44.1463 110.224 47.5919C111.901 51.0375 112.772 54.8194 112.772 58.6514V58.6514Z",
    fill: "#5100CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.328 101.971C103.328 101.971 110.473 218.591 90.2925 273.807",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1095 39.8683C69.1095 39.8683 33.7885 58.5541 11.1361 103.566C-11.5164 148.577 7.36917 154.344 13.0323 153.282C18.6954 152.221 17.9875 143.726 17.9875 143.726C17.9875 143.726 22.5888 145.85 22.5888 144.08C22.5888 142.945 21.5669 140.094 20.8334 138.194C20.341 136.91 20.3417 135.489 20.8353 134.206C23.5264 127.155 34.6474 101.61 70.3688 83.2727",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.406 39.8683C104.406 39.8683 117.084 48.5861 123.455 76.4298C123.455 76.4298 122.275 55.665 121.095 55.1931C119.915 54.7211 116.612 46.9344 121.803 48.1142C121.803 48.1142 120.151 41.0353 126.758 43.1589C133.365 45.2826 148.231 77.1376 143.276 92.9472C138.32 108.757 128.146 110.112 128.146 110.112",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7473 92.7376L54.9918 124.619L65.9825 85.6304C62.113 87.7968 58.3626 90.1693 54.7473 92.7376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M218.408 192.606C227.937 192.606 235.662 184.881 235.662 175.352C235.662 165.823 227.937 158.098 218.408 158.098C208.879 158.098 201.154 165.823 201.154 175.352C201.154 184.881 208.879 192.606 218.408 192.606Z",
    fill: "#5100CE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople5);
export default __webpack_public_path__ + "static/media/people-5.f6da3ec0c606247b1977396915df3b54.svg";
export { ForwardRef as ReactComponent };